export const dashboardWidgets = {
  upcoming: {
    title: "Najbliższe przyjazdy",
    empty: "Brak nadchodzących wydarzeń",
    createBooking: "Utwórz rezerwację",
  },
  lastActivity: {
    title: "Ostatnia aktywność",
  },
  portals: {
    title: "Zsynchronizowane kanały rezerwacji",
    connectedSuccess: "Połączono pomyślnie",
    unknownChannel: "Nieznany",
    connectNewChannel: "Podłącz nowy kanał",
    empty: "Brak zsynchronizowanych kanałów",
    connectChannel: "Podłącz kanał",
    loadError: "Nie udało się wczytać portali",
    errorTitle: "Błąd",
  },
};
